import * as React from 'react';
import { ListViewModelImpl } from '../../../../../toolkit/horizontallist/listviewmodel';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { ToneCardCSSStyle, ToneCardCSSStyleImpl } from '../../../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ToneEvenCardCSSStyleImpl } from '../../../featuredcategory/viewmodel/tonecard/toneevencardcssstyle';
import { ToneCardComponent } from '../../../featuredcategory/viewmodel/tonecard/tonecardcomponent';
import { SearchListToneCardPlayerCSSStyleImpl } from '../../../searchlist/searchlisttonecardplayercss';
import { ToneRowOptionsPrivilage,  ToneRowOptionsPrivilageImpl } from '../../../../../toolkit/toneoptions/tone/tonerowcomponent';
import { ToneCardPlayerCSSStyleImpl } from '../../../featuredcategory/viewmodel/tonecard/tonecardplayercss';
import { ToneMobileCardPlayerCSSStyleImpl } from '../../../featuredcategory/viewmodel/tonecard/tonemobilecardplayercss';

export class BannerToneRowOptionsPrivilageImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setGift(true);
        this.setShare(true);
        this.setAddWishList(true);
        this.setTellAFriend(true);
        this.setBuy(true);
        this.setLike(true);
        this.setPlay(true);
        this.setAction(true);
    }
}

export class BannerListToneViewModelImpl extends ListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    private privilage: ToneRowOptionsPrivilage;
     private audioPlayerWithProgress: AudioPlayerWithProgress;
    private playerCSSStyle: SearchListToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle: ToneCardPlayerCSSStyleImpl;
    private map: Map<number, ToneCardComponent>;
  
    constructor(context: BaseContext, private marginTop: string, title: string)
    {
        super(context);
        this.onToneSelected = this.onToneSelected.bind(this);
        this.map = new Map<number, ToneCardComponent>();
        this.toneOddCardCSSStyle = new ToneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new ToneEvenCardCSSStyleImpl(context);
        this.privilage = new BannerToneRowOptionsPrivilageImpl();
        this.playerCSSStyle = new SearchListToneCardPlayerCSSStyleImpl(context);
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());

        this.playerMobileCSSStyle = new ToneMobileCardPlayerCSSStyleImpl(context);
    }

    // setTitle(title: string)
    // {
    //     this.title = title;
    // }

    getOffset(): number
    {
        return 5;
    }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} ref={(item: any)=>{this.map.set(position,item);}} isPlayInitial={position === 0} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.privilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneOddCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} ref={(item: any)=>{this.map.set(position,item);}} isPlayInitial={position === 0} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.privilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneEvenCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

    playFirstTone(position: number)
    {
        let toneComponent:ToneCardComponent|undefined = this.map.get(position);

        if(toneComponent!== undefined)
        {
            toneComponent.playStart();
        }
    }
    protected onToneSelected(): void
    {
       
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerlist/tones/bannerlistviewmodel.tsx